import { legacy_createStore as createStore } from 'redux'

const savedToken = localStorage.getItem('token')
const savedUser = localStorage.getItem('user')

const initialState = {
  sidebarShow: true,
  theme: 'light',
  token: savedToken || null,
  user: savedUser ? JSON.parse(savedUser) : null,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'SET_AUTH':
      localStorage.setItem('token', rest.token)
      localStorage.setItem('user', JSON.stringify(rest.user))
      return { ...state, token: rest.token, user: rest.user }
    case 'CLEAR_AUTH':
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      return { ...state, token: null, user: null }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
